module.exports = __webpack_public_path__ + "media/images/menu/oberon-7707d7ef541fdd017a0e01ae241b60db.jpg";